var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.countries)?_c('div',[_c('div',{staticClass:"country-list is-flex is-flex-direction-row"},_vm._l((_vm.displayCountries),function(ref){
var name = ref.name;
var code = ref.code;
return _c('div',{key:code},[_c('div',{staticClass:"country-name is-flex is-flex-direction-row"},[_c('div',{staticClass:"mr-1 has-flag"},[_c('CountryFlag',{attrs:{"code":code}})],1),_c('div',{staticClass:"mr-2"},[_vm._v(" "+_vm._s(name)+" ")])])])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }